import { RequestError } from 'shared/domain/http/request-error';

export class AppError<T> extends Error {
  public readonly code: T;
  public readonly message: string;
  public readonly status: number;
  public readonly title: string;

  public constructor({ message, title, code, status }: RequestError<T>) {
    super(message);
    this.code = code;
    this.message = message;
    this.status = status;
    this.title = title;

    Object.setPrototypeOf(this, AppError.prototype);
  }
}
